import { useEffect, useState } from 'react';
import { mintTotal } from './api';

/**
 * How many Eyes have been minted so far, from /mint/totalCount. Null until
 * the first response arrives (or if it fails).
 */
export default function useMintTotal() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    let cancelled = false;
    mintTotal()
      .then((results) => {
        if (!cancelled) setTotal(Number(results.data));
      })
      .catch((e) => console.log(e));
    return () => {
      cancelled = true;
    };
  }, []);

  return total;
}
